module.exports = __webpack_public_path__ + "static/media/_MG_6283.18e21a04.jpg";